import { Dispatch } from "@reduxjs/toolkit";
import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { getCmmInputDataForOrder } from "../../../api/bigQuery/nycbsPharmaOrders";
import { mapToCoverMyMedsInputModel } from "../../../data-model/cmmInputRequestModel";
import { closeModal } from "../../../redux/slice/modalSliceNew";
import { runStatusTrackingBatch } from "../apis/runStatusTrackingBatch";

export const handleRerunModalSave = async (
  identifier: string,
): Promise<void> => {
  const orderDataResponse = await getCmmInputDataForOrder(identifier);
  const orderData = orderDataResponse?.["details"];
  if (!orderData) {
    throw new Error("Failed to fetch order data");
  }
  const completePayload = mapToCoverMyMedsInputModel(orderData);
  const abortController = new AbortController();
  const batchPayload = {
    cover_my_meds_input_list: [completePayload],
    batch_id: `rerun-batch-${identifier}-${Date.now()}`,
    batch_index: 0,
    total_batches: 1,
  };

  // Call the run status tracking batch API
  await runStatusTrackingBatch(abortController.signal, batchPayload);
};

interface HandleSaveSftpRerunActionParams {
  dispatch: Dispatch;
  selectedRerunIdentifier: string | null;
  setIsRerunning: (value: boolean) => void;
  setSelectedRerunIdentifier: (value: string | null) => void;
}

/**
 * Handler for SFTP Rerun modal save action
 * Handles the complete flow: API call, success/error toasts, and modal cleanup
 */
export const handleSaveSftpRerunAction = async ({
  dispatch,
  selectedRerunIdentifier,
  setIsRerunning,
  setSelectedRerunIdentifier,
}: HandleSaveSftpRerunActionParams): Promise<void> => {
  setIsRerunning(true);

  try {
    await handleRerunModalSave(selectedRerunIdentifier ?? "");
    toast.success(
      "Rerun initiated successfully! Please check back in a few minutes.",
    );
  } catch (error) {
    console.error("Failed to rerun:", error);
    toast.error("Failed to initiate rerun. Please try again.");
  } finally {
    // Small delay before closing modal for better UX
    setTimeout(() => {
      dispatch(closeModal());
      setSelectedRerunIdentifier(null);
      setIsRerunning(false);
    }, 1000);
  }
};
